import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import {JsonClientService} from '../../../shared/json-client';

@Injectable()
export class ManagersEditResolve {

  constructor(public http: JsonClientService) { }

  resolve(route: ActivatedRouteSnapshot) {
    return this.http.post('Developer.manager_read', {'manager_id': route.params['id']});
  }
}
